import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';

import { UserData } from '../types';

import { USER_DATA_INITIAL_STATE } from '../constants';

type UserContextData = {
  userData: UserData;
  setUserData: Dispatch<SetStateAction<UserData>>;
};

const userContextDefaultValue: UserContextData = {
  userData: USER_DATA_INITIAL_STATE,
  setUserData: () => null,
};

export const UserContext = createContext<UserContextData>(userContextDefaultValue);

export const useUserContextValue = (): UserContextData => {
  const [userData, setUserData] = useState<UserData>(USER_DATA_INITIAL_STATE);

  return useMemo(() => ({
    userData,
    setUserData,
  }), [userData]);
};
